import {DirectusTranslation} from '@frontend/directus';

export enum ModuleSelectionState {
  NONE = 'NONE',
  SOME = 'SOME',
  ALL = 'ALL',
}

export interface FunctionalScopeChip {
  functionId: string;
  functionTranslations: DirectusTranslation[];
  statusTranslations: DirectusTranslation[];
}
